import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { setMaterialId } from '@pages/reporting-pages/deliveries-sku-dc/store/slice';



interface SkuClickParams {
	dateFrom: string,
	dateTo: string,
	materialClientId: string,
}


const useSkuClick = (params: SkuClickParams) => {
	const { dateFrom, dateTo, materialClientId } = params;
	
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const updateMaterialId = (value: string) => dispatch(setMaterialId(value));
	
	
	const clickToOrder = useCallback(() => {
		if (dateFrom && dateTo && materialClientId) {
			updateMaterialId(materialClientId);
			navigate(NavigateRoutesEnum.reportingDeliveriesSkuDc);
		}
	},[ dateFrom, dateTo, materialClientId ]);
	
	
	return clickToOrder;
};

export default useSkuClick;